module.exports = __webpack_public_path__ + "img/icon-search.28106493.svg";